// https://www.py4u.net/discuss/322092
import * as queryString from 'query-string';

const preserveQueryParameters = (history, preserve, location) => {
  const currentQuery = queryString.parse(history.location.search);
  if (currentQuery) {
    const preservedQuery = {};
    for (const p of preserve) {
      const currentValue = currentQuery[p];
      if (currentValue) {
        preservedQuery[p] = currentValue;
      }
    }
    if (location.search) {
      Object.assign(preservedQuery, queryString.parse(location.search));
    }
    location.search = queryString.stringify(preservedQuery);
  }
  return location;
};

const createLocationDescriptorObject = (location, state) =>
  typeof location === 'string' ? { pathname: location, state } : location;

const createPreserveQueryHistory = (createHistory, queryParameters) => options => {
  const history = createHistory(options);
  const oldPush = history.push;
  const oldReplace = history.replace;

  history.push = (path, state) =>
    oldPush.apply(history, [
      preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))
    ]);
  history.replace = (path, state) =>
    oldReplace.apply(history, [
      preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))
    ]);
  return history;
};

export default createPreserveQueryHistory;



// WEBPACK FOOTER //
// ./containers/app/preserve-query-parameters.js